import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gonghaikehu",
  "use": "icon-gonghaikehu-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-gonghaikehu\"><path d=\"M10.326 11.603l1.988 1.987 1.987-1.987.723.727-2.71 2.71-1.99-1.987-1.985 1.987-2.713-2.71.723-.727 1.987 1.987 1.987-1.987zM7.51.96a3.973 3.973 0 013.786 5.171h-1.094A2.95 2.95 0 007.51 1.984a2.95 2.95 0 00-2.948 2.944c0 1.286.826 2.38 1.975 2.784v1.069l-.07.016a5.832 5.832 0 00-2.83 1.571 5.824 5.824 0 00-1.625 3.085H.976A6.907 6.907 0 015.171 8.14 3.973 3.973 0 017.511.96z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/gonghaikehu.svg
// module id = 464
// module chunks = 4